import { render } from "./DocLeftMenu.vue?vue&type=template&id=6de919a9&scoped=true&ts=true"
import script from "./DocLeftMenu.vue?vue&type=script&lang=ts"
export * from "./DocLeftMenu.vue?vue&type=script&lang=ts"

import "./DocLeftMenu.vue?vue&type=style&index=0&id=6de919a9&lang=scss&scoped=true"

import exportComponent from "E:\\datedu-web-master(qiankun)\\project-open-api\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6de919a9"]])

export default __exports__